import React, { useEffect, useRef, useState } from "react";
import { Loader, SubmitBar } from "@egovernments/digit-ui-react-components";
import { Row, Col, Card, Container } from "react-bootstrap";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { Link, useParams } from "react-router-dom";
import ReactToPrint from "react-to-print";
// import FormatSlip from "./FormatSlip";
import { ToWords } from "to-words";
import PrintIcon from "@mui/icons-material/Print";
import { Button, CircularProgress } from "@mui/material";
// import LogoUrlData from "../../LogoUrl";
import PaymentReceipt from "./PaymentFormatSlip";
import Urls from "@egovernments/digit-ui-libraries/src/services/atoms/urls";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";

const PaymentPrint = (props) => {
  const { authority, plan, form, year, serial, tenantId } = useParams();

  const id = `${authority}/${plan}/${form}/${year}/${serial}`;

  const formType = form === "LU" ? "formLandUse" : "";
  const { t } = useTranslation();
  const stateId = Digit.ULBService.getStateId();
  const conponentPDF = useRef();
  const toWords = new ToWords();
  const [loader, setLoader] = useState(false);
  const [logoUrl, setLogoUrl] = useState("");
  // const [logoData, setLogoData] = useState(null);
  const [loading, setLoading] = useState(false);
  console.log("idFromOurcomponent", id, authority, plan, form, year, serial, tenantId);
  const { data: { BPA: { logoStore } = {} } = {}, isLoading: isLogoLoading } = Digit.Hooks.obps.useMDMS("up", "BPA", ["logoStore"]);
  const avpLogo = logoStore?.find((item) => item.code === "up.avp");
  const daLogo = logoStore?.find((item) => item.code === "up.da");
  const [scrutinyTable, setScrutinyTable] = useState(null);
  const [isPreviewLoading, setIsPreviewLoading] = useState(false);
  const [amountDetails, setAmountDetails] = useState(null);
  const userInfo = Digit.UserService.getUser()?.info || {};
  const authToken = Digit.UserService.getUser()?.access_token || null;
  const getApplicationPay = async () => {
    setLoader(true);
    // const token = window?.localStorage?.getItem("token");

    let requestInfo = {
      RequestInfo: {
        apiId: "Rainmaker",
        ver: "v1",
        ts: 0,
        action: "_search",
        did: "",
        key: "",
        msgId: "090909",
        requesterId: "",
        authToken: authToken,
        userInfo: userInfo,
      },
    };
    try {
      const Resp = await axios.post(`/pg-service/transaction/v1/_search?consumerCode=${id}`, requestInfo).then((response) => {
        return response?.data;
      });
      setLoader(false);
      console.log("Responsdhgdhdeygfg", Resp);
      setScrutinyTable(Resp?.Transaction?.[0]);
      const amountPaid = Resp?.Transaction?.[0]?.additionalDetails?.taxAndPayments[0]?.amountPaid;
      if (amountPaid > 1) {
        const wordsList = toWords.convert(amountPaid, { currency: true, ignoreDecimal: false });
        setAmountDetails(wordsList);
        console.log("5555555555", wordsList);
      } else if (amountPaid === 1) {
        const wordstr = "One Rupee Only";
        setAmountDetails(wordstr);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getApplicationPay("");
  }, [id]);
  const { data: applicationData = {}, isLoading: paymentStatus } = Digit.Hooks.obps.useBPADetailsPage(
    stateId,
    { applicationNo: id },
    { formType: formType }
  );
  console.log(applicationData, "aplicationData");
  const isDA = applicationData?.applicationData?.department === "DA" || applicationData?.LandUse?.[0]?.department === "DA";
  const locationDistrict = applicationData?.applicationData?.locationDistrict || applicationData?.LandUse?.[0]?.location1;
  const currentLogoId = isDA ? daLogo?.boundary?.find((item) => item.name === locationDistrict)?.fileStoreId : avpLogo?.fileStoreId;
  console.log("currentLogoIdFromReceipt", currentLogoId, logoStore);
  const business_service = applicationData?.businessService;
  const { eg_pg_txnid: egId, txnStatus: txn, workflow: workflw } = Digit.Hooks.useQueryParams();
  const { isLoading: paymentLoading, data, isError } = Digit.Hooks.usePaymentUpdate({ egId, txn }, business_service, {
    retry: false,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
  });
  //  logo Functionality and API
  useEffect(() => {
    const fetchLogoUrl = async () => {
      if (!currentLogoId) return;
      setLoading(true); // Notify parent loading started
      const result = await getDocumentByFileStoreId(currentLogoId, setIsPreviewLoading, true);
      setLogoUrl(result);
      setLoading(false);
    };
    fetchLogoUrl();
  }, [locationDistrict, isDA]);

  // useEffect(() => {
  //   const fetchData = async () => {
  //     if (!applicationData?.applicationData?.department) return;

  //     setLoading(true); // Notify parent loading started
  //     const authToken = Digit.UserService.getUser()?.access_token;

  //     const requestInfo = {
  //       RequestInfo: {
  //         apiId: "Rainmaker",
  //         msgId: "1669293303096|en_IN",
  //         authToken: authToken,
  //       },
  //     };

  //     let url = `${Urls.logoUrl.bpaLogoUrl}department=${applicationData?.applicationData?.department}`;
  //     if (applicationData?.applicationData?.department !== "AVP" && applicationData?.applicationData?.locationDistrict) {
  //       url += `&district=${applicationData?.applicationData?.locationDistrict}`;
  //     }

  //     try {
  //       const response = await axios.post(url, requestInfo);
  //       setLogoData(response?.data); // Send data back to parent
  //       // setLoading(false);
  //       console.log("Logo API response:", response?.data);
  //     } catch (error) {
  //       console.error("Logo API call failed:", error);
  //       setLogoData(null); // Clear or handle in parent
  //     } finally {
  //       console.error("finally:", error);
  //       setLoading(false); // Notify parent loading ended
  //     }
  //   };

  //   fetchData();
  // }, [applicationData?.applicationData?.department, applicationData?.applicationData?.locationDistrict]);

  // useEffect(() => {
  //   if (logoData) {
  //     setLoading(false);
  //   } else {
  //     setLoading(true);
  //   }
  // }, [logoData]);

  if (loading || loader || paymentStatus) {
    return <Loader />;
  }

  return (
    <Container
      className="justify-content-center"
      style={{
        minWidth: "100%",
        maxWidth: "100%",
        maxHeight: "50%",
        minHeight: "40%",
        marginTop: 5,
      }}
    >
      {/* <LogoUrlData
        department={applicationData?.applicationData?.department}
        district={applicationData?.applicationData?.locationDistrict}
        onDataFetched={setLogoData}
        onLoadingChange={setLoading}
      /> */}
      {/* {loading && <div style={{ display: "flex", alignItems: "center", gap: "10px", padding: "10px" }}>
    <CircularProgress size={20} />
    <span>Loading logo...</span>
  </div>} */}

      <Card>
        <div ref={conponentPDF}>
          <div>
            {/* <FormatSlip scrutinyTable={scrutinyTable} scrutinyDetails={applicationData?.applicationData || applicationData?.LandUse?.[0]} wordslist={amountDetails} /> */}
            <PaymentReceipt
              scrutinyTable={scrutinyTable}
              scrutinyDetails={applicationData?.applicationData || applicationData?.LandUse?.[0]}
              wordslist={amountDetails}
              logoData={logoUrl}
            />
          </div>
        </div>

        <Row className="justify-content-space-between" style={{ padding: "10px", marginTop: 20 }}>
          <Col xs="4">
            <Link to={`/digit-ui/citizen/profile`}>
              <SubmitBar style={{ marginLeft: "85px" }} label={t("CORE_COMMON_GO_TO_HOME")} />
            </Link>
          </Col>
          <Col xs="4"></Col>
          <Col xs="4">
            <ReactToPrint
              trigger={() => (
                <Button
                  class="btn btn-success"
                  id="invoice-print"
                  variant="outlined"
                  startIcon={<PrintIcon />}
                  // onClick={handlePrint}
                >
                  Print
                </Button>
              )}
              content={() => conponentPDF.current}
            />
          </Col>
        </Row>
      </Card>
    </Container>
  );
};

export default PaymentPrint;
